import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import * as styles from './styles';
import { Props } from './types';

export default function HeaderComponent({ title, subTitle, goBackTo }: Props) {
  const navigate = useNavigate();
  return (
    <Grid container>
      <Grid sx={styles.headerContainer} item xs={12} md={1}>
        {goBackTo && (
          <>
            <IconButton onClick={() => navigate(goBackTo)} sx={styles.iconGoback}>
              <ArrowBackIosNewRoundedIcon />
            </IconButton>
          </>
        )}
      </Grid>
      <Grid item xs={12} md={11} sx={styles.headerContainer}>
        <Box>
          <Typography
            sx={{ fontSize: { xs: 20, sm: 24 }, marginLeft: '0.5rem' }}
            variant="h5"
            component="h1"
            fontWeight="bold"
          >
            {title}
          </Typography>
          {subTitle && (
            <>
              <Typography sx={{ fontSize: { xs: 20, sm: 24 } }} variant="h5" component="h1" fontWeight="bold">
                {subTitle}
              </Typography>
            </>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}
